import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import UploadFile from "@mui/icons-material/UploadFile";
import Task from "@mui/icons-material/Task";
import FolderOpenTwoTone from "@mui/icons-material/FolderOpenTwoTone";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
toast.configure();

const MrpUpdate = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };
  //TIMEOUT WHEN JWT EXPIRES
  setTimeout(() => {
    window.location.reload(false);
  }, 1800000);

  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [importDisabled, setImportDisabled] = useState(true);
  const [isloading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("file", file);
      const response = await fetch("/uploadmrplist", {
        method: "POST",
        headers: { sptoken: userToken },
        body: data,
      });
      const parseRes = await response.json();
      if (!response.ok) {
        toast.error(parseRes.message || "Upload failed", { autoClose: 3000 });
        return;
      }
      toast.success(parseRes, { autoClose: 2000 });
      setImportDisabled(false);
      setDisabled(true);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleImport = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(`/importmrplist/${fileName}`, {
        method: "POST",
        headers: { sptoken: userToken },
      });
      const parseRes = await response.json();
      console.log(parseRes);
      if (parseRes.type === "success") {
        toast.success(parseRes.message, { autoClose: 1000 });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        toast.error(parseRes.message || "Import failed", { autoClose: 5000 });
      }
    } catch (err) {
      console.log(err.message);
      toast.error("Import failed", { autoClose: 5000 });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div>
        <Sidebar
          Title={"MRP Update"}
          expandedPanel={"panel4"}
          children={
            <Box
              component="form"
              sx={{
                width: "100%",
              }}
              Validate
              // onSubmit={handleSubmit}
              autoComplete="off"
            >
              <Stack ml={"34%"} mt={"100px"} mb={5} direction="row">
                <Typography variant="h5">
                  IMPORT PRICELIST WITH CATEGORY AND SUBGROUP FROM EXCEL
                </Typography>
              </Stack>

              <hr />
              {isloading ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: 10,
                  }}
                >
                  <CircularProgress />

                  <Typography mt={3} fontWeight={"bold"} textAlign="center">
                    Please Wait... It Might Take Up to 5 minutes to Update!!
                  </Typography>
                </Box>
              ) : (
                <>
                  <Stack
                    spacing={2}
                    ml={"34%"}
                    mt={"100px"}
                    direction="row"
                    align="center"
                  >
                    <IconButton
                      aria-label="upload picture"
                      component="label"
                      sx={{ color: "#e69b00" }}
                    >
                      <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          setFileName(e.target.files[0].name);
                          setFile(e.target.files[0]);
                          setDisabled(false);
                        }}
                      />
                      <FolderOpenTwoTone
                        sx={{ width: "45px", height: "45px" }}
                      />
                    </IconButton>
                    <TextField
                      disabled
                      id="filename"
                      label="File Name"
                      variant="standard"
                      value={fileName}
                      type="text"
                      sx={{
                        width: "36%",
                      }}
                    />
                  </Stack>
                  <Stack spacing={20} ml={"29%"} mt={"80px"} direction="row">
                    <Button
                      disabled={disabled}
                      type="submit"
                      onClick={handleSubmit}
                      variant="contained"
                      component="label"
                      color="success"
                      size="large"
                      sx={{ boxShadow: "2px 2px 6px  #404142", px: 5, py: 2 }}
                      endIcon={<UploadFile />}
                    >
                      UPLOAD
                    </Button>
                    <Button
                      type="submit"
                      disabled={importDisabled}
                      onClick={handleImport}
                      variant="contained"
                      component="label"
                      size="large"
                      sx={{ boxShadow: "2px 2px 6px  #404142", px: 5, py: 2 }}
                      endIcon={<Task />}
                    >
                      IMPORT
                    </Button>
                  </Stack>
                </>
              )}
            </Box>
          }
        />
        {/* <FooterElement /> */}
        {redirectToLoginPage()}
      </div>
    </>
  );
};

export default MrpUpdate;
